/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstAnyOpts, SchemaConstAny, ISchemaConstAny } from "../const/SchemaConstAny";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueAnyOpts extends ISchemaValueOpts<ISchemaConstAny>, ISchemaConstAnyOpts {}

/**
 * Schema: Boolean value
 *
 * @param opts Schema options
 */
export function SchemaValueAny(opts: ISchemaValueAnyOpts): ISchemaValue<ISchemaConstAny> {

	return SchemaValue(SchemaConstAny(opts), opts);

}